export const ProfileStore = {
    state: () => ({
        profile: {},
        address: {},
        shipping: {},
        isLoaded: false, 
    }),
    mutations: {
        setAllProfile: function(state, profile) {
            if (profile) {
                state.profile = profile.profile;
                state.address = profile.address;
                state.shipping = profile.shipping;
                state.isLoaded = true;
            }
        },
        setProfile: function (state, profile) {
            if (profile) {
                state.profile = profile;
            }
        },
        setAddress: function (state, address) {
            if (address) {
                state.address = address;
            }
        },
        setShipping: function (state, shipping) {
            if (shipping) {
                state.shipping = shipping;
            }
        },
        updatePoints: function(state, point) {
            state.profile.updated_points.points = point;
        },
        updateLocale: function (state, localeCode) {
            state.profile.locale = localeCode;
        },
    },
    getters: {
        getAddress: function (state) {
            return state.address;
        },
        getShipping: function (state) {
            return state.shipping;
        },
        isProfileLoaded: function(state) {
            return state.isLoaded;
        },
    },
    actions: {
        setProfile: function (context, profile) {
            let data = {
                profile: profile,
            };
            context.commit('setProfile', data);
        },
    },
};
